import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileSizePipe } from './file-size.pipe';
import { OrderByPipe } from './orderby.pipe';
import { TextMapperPipe } from './text-mapper.pipe';
import { TitleMapperPipe } from './title-mapper.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TextMapperPipe, TitleMapperPipe, FileSizePipe, OrderByPipe],
  exports: [TextMapperPipe, TitleMapperPipe, FileSizePipe, OrderByPipe]
})
export class CustomPipesModule {}
export {TextMapperPipe} from './text-mapper.pipe';
